import { Injectable } from '@angular/core';
import { ISalesByProductSettings, ISalesByProductSettingsRemote } from './interfaces';

@Injectable({
    providedIn: 'root',
})
export class SalesByProductWidgetService {
    areSettingsValid(definitionSettings: ISalesByProductSettings): boolean {
        if (!definitionSettings?.remote) {
            return false;
        }
        return !!(definitionSettings?.remote?.event_id && definitionSettings.remote.product_ids?.length > 0);
    }

    areRemoteSettingsEmpty(settings: ISalesByProductSettingsRemote): boolean {
        if (!settings || !settings.event_id || !settings.product_ids) {
            return true;
        }
        return false;
    }

    setDefaultRemoteSettingsIfMissing(settings: ISalesByProductSettings, eventId: string): void {
        settings.remote ||= {} as ISalesByProductSettingsRemote;
        settings.remote.event_id ||= eventId;
        settings.remote.product_ids ||= [];
    }
}
